<template>
    <div>
        <el-table :data="listData" border stripe style="width: 100%;border-radius: 10px;"
            :header-cell-style="{ textAlign: 'center', backgroundColor: '#b3e0ff' }"
            :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
            <el-table-column prop="storeName" label="门店名称" width="120"></el-table-column>
            <el-table-column prop="payTypeStr" label="收款方式" width="90"></el-table-column>
            <el-table-column prop="payMoney" label="收款金额（元）" width="150"></el-table-column>
            <el-table-column prop="content" label="收款内容"></el-table-column>
            <el-table-column prop="payComment" label="收款备注" width="150"></el-table-column>
            <el-table-column prop="creator" label="经办人" width="90"></el-table-column>
            <el-table-column prop="createTime" label="经办时间" width="170"></el-table-column>
        </el-table>
    </div>
</template>

<script>
import {
    GetPayHistoryList
} from "@/api/payApi.js";
export default {
    data() {
        return {
            loading: false, // 显示加载
            listData: [],
            formInline: {
                keyId: "",
            },
        };
    },
    // 注册组件
    components: {

    },
    created() {

    },
    computed: {},
    methods: {
        showPayReord(val) {
            this.formInline.keyId = val;
            this.getListData();
        },
        // 获取列表
        getListData() {
            this.loading = true;
            GetPayHistoryList(this.formInline)
                .then((res) => {
                    if (res.code == 1) {
                        this.loading = false;
                        this.listData = res.data;
                    } else {
                        this.$message({
                            type: "info",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("数据加载失败，请稍后再试！");
                }).finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style scoped></style>